import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function getJourneys(params = {}) {
	return axios({
		method: 'get',
		url: `${API_URL}/journeys`,
		params,
	});
}

export function showJourney(slug, options = {}) {
	return axios({
		method: 'get',
		url: `${API_URL}/journeys/${slug}`,
		skipGlobalError: options.skipGlobalError === true,
	});
}
